import React, { Fragment } from "react";

const DoYouNeedAuthorisation = {
  requiresAuthorisation: {
    International: (props, { TelephoneClaims }) => (
      <Fragment>
        Unfortunately, we're unable to authorise this type of treatment online.
        Please call us on <strong>{TelephoneClaims}</strong> to discuss your
        treatment. Lines are open 24 hours a day, 365 days a year.
      </Fragment>
    ),
    Format2: (props, { TelephoneClaims }) => (
      <Fragment>
        Unfortunately, we're unable to authorise this type of treatment online.
        Please call us on <strong>{TelephoneClaims}</strong> to discuss your
        treatment. Lines are open 8am-8pm, Monday-Friday; 9am-5pm Saturday.
      </Fragment>
    ),
    Any: (props, { TelephoneClaims, OpeningHoursClaims }) => (
      <Fragment>
        Unfortunately, we're unable to authorise this type of treatment online.
        Please call us on <strong>{TelephoneClaims}</strong> to discuss your
        treatment. Lines are open {OpeningHoursClaims}.
      </Fragment>
    )
  },
  questionForNewClaim: (
    <React.Fragment>
       Do you need authorisation for Chemotherapy/Radiotherapy?
    </React.Fragment>
  ),
  questionForExistingClaim: (
    <React.Fragment>
       Do you need authorisation for Chemotherapy/Radiotherapy?
    </React.Fragment>
  ),
  option1Label: "Yes",
  option2Label: "No"
};

export default DoYouNeedAuthorisation;
